<template>
    <div class="HdIndex">
        <div class="banner-wrap clear tc" v-if="banner.length>0">
            <el-carousel :interval="2000" type="card" height="360px" arrow="always">
                <el-carousel-item v-for="(item,index) in banner" :key="item.innerid">
                    <div @click="routeAdvertisement(item.clickurl)" :class="'swiperitem swiper_'+index" :style="{width: '100%', height: '360px', backgroundImage: 'url('+ item.adurl +')', backgroundSize: 'cover',  backgroundPosition: 'center', backgroundRepeat: 'no-repeat'}"></div>
                </el-carousel-item>
            </el-carousel>
        </div>
        <!--下面部分-->
        <div class="index_wrap">
            <!--推荐活动-->
            <div class="list_box" style="position: relative">
                <div class="t margin30">
                    <div class="title">推荐活动</div>
                </div>
                <!--推荐轮播-->
                <el-carousel indicator-position="outside"  :interval="400000" height="280px">
                    <el-carousel-item  v-for="(item,index) in recommendlist" :key="index">
                        <div class="list">
                            <div class="list_item"  v-for="(list,ind) in item" :key="ind">
                                <template>
                                    <IndexList  :type="1" :dataList="list"></IndexList>
                                </template>
                            </div>
                        </div>
                    </el-carousel-item>
                </el-carousel>
            </div>
            <section class="advertisement page-module" v-if="advertisement1.adurl" @click="routeAdvertisement(advertisement1.clickurl)"><img v-lazy="advertisement1.adurl" :alt="advertisement1.adtitle">
            </section>
            <!--最新活动-->
            <div class="list_box flex_listBox">
                <div class="left">
                    <div class="t" style="margin-bottom: 10px">
                        <div class="title">最新活动</div>
                        <div class="more" @click="moreClick">更多>></div>
                    </div>
                    <div class="active_list">
                        <IndexList  v-for="(item,index) in newevent" :key="index" :dataList="item"></IndexList>
                    </div>
                </div>
                <div class="right">
                    <RankList :dataList="ranklist"></RankList>
                </div>
            </div>
            <section class="advertisement page-module" v-if="advertisement2.adurl" @click="routeAdvertisement(advertisement2.clickurl)"><img v-lazy="advertisement2.adurl" :alt="advertisement2.adtitle">
            </section>
            <!--猜你喜欢-->
            <div class="list_box">
                <div class="t margin-30">
                    <div class="title">猜你喜欢</div>
                    <div class="more" @click="_refresh"><img :src="refresh" alt=""> 换一批</div>
                </div>
                <div class="like_list">
                    <div class="likeItem" v-for="(item,index) in likeList" :key="index">
                        <IndexList  :dataList="item"></IndexList>
                    </div>
                </div>
                <div class="seeMore" @click="moreClick"><img :src="under_ison" alt="">查看更多活动</div>
            </div>
            <!--活跃主办方-->
            <div class="list_box">
                <div class="t">
                    <div class="title">活跃主办方</div>
                </div>
                <div class="sponsor_wrap" v-if="activehost&&activehost.length>0">
                    <div class="leftBox" @click="goHostDet(activehost[0].hostid)">
                        <img :src="activehost[0].hostpic" alt="">
                        <div class="desp">
                            <p class="title">{{activehost[0].hostname}}</p>
                            <p class="rowTwo">{{activehost[0].hostdesp}}</p>
                            <p>活动  {{activehost[0].eventcount}}<b class="rowline">|</b>粉丝  {{activehost[0].eventcount}}</p>
                        </div>
                    </div>
                    <div class="rightBox">
                        <div v-for="(item,index) in activehost" :key="index" @click="goHostDet(item.hostid)">
                            <div class="sponsorList" v-if="index>0">
                                <img :src="item.hostpic" alt="">
                                <div class="desp">
                                    <p class="title">{{item.hostname}}</p>
                                    <p class="rowTwo">{{item.hostdesp}}</p>
                                    <p>活动 {{item.eventcount}}<b class="rowline">|</b>粉丝 {{item.favoritecount}}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- <IndexSilder></IndexSilder> -->
    </div>
</template>

<script>
    import {getIndexInfo,getGuessLikeList} from 'api/hdApi'
    import {mapGetters,mapActions} from 'vuex'
    import {getAdConfig} from 'api/systemApi'
    import IndexList from '@/views/hdPc/components/indexList'
    // import IndexSilder from '@/views/hdPc/components/indexSilder'
    import RankList from '@/views/hdPc/components/rankList'
    export default {
        name: "HdIndex",
        data(){
            return{
                adv:require('@/common/images/hd/adv.png'),
                under_ison:require('@/common/images/hd/under_ison.png'),
                refresh:require('@/common/images/hd/refresh.png'),
                banner:[], //banner
                recommendlist:[], //推荐活动
                ranklist:[], //排行榜
                newevent:[], //最新活动
                likeList:[], //猜你喜欢
                activehost:[], //活跃主办方
                advertisement1: [], // 广告1
                advertisement2: []  // 广告2
            }
        },
        created(){
            if(this.domainInfo.isMobile){
                this.$router.push({
                    name: 'ApplyIndex'
                })
            }
        },
        mounted(){
            this._getInfo();
            this._getLike();
            //获取广告
            this.getAdvertisement("E01", (data)=> {
                this.banner = data
            });
            this.getAdvertisement("E03", (data)=> {
                this.advertisement1 = data&&data.length>0?data[0]:''
            });
            this.getAdvertisement("E04", (data)=> {
                this.advertisement2 = data&&data.length>0?data[0]:''
            })
        },
        methods:{
            // 获取首页信息
            _getInfo(){
                this.setLoading(true);
                getIndexInfo({
                    data: Object.assign({}, ''),
                    success: data => {
                        this.setLoading(false);
                        this.getRecommendlist(data.data.recommendlist)
                        this.ranklist=data.data.ranklist
                        this.newevent=data.data.newevent
                        this.activehost=data.data.activehost
                    },
                    error: data => {
                        this.$message.error(data.msg)
                    }
                })
            },
            getRecommendlist(item){
                this.recommendlist[0] =  item.splice(0,4)
                this.recommendlist[1] =  item.splice(0,4)
                this.recommendlist[2] =  item.splice(0,4)
            },
            // 获取猜你喜欢
            _getLike(){
                this.setLoading(true);
                getGuessLikeList({
                    data: Object.assign({}, ''),
                    success: data => {
                        this.setLoading(false);
                        this.likeList=data.data
                    },
                    error: data => {
                        this.$message.error(data.msg)
                    }
                })
            },
            //更多
            moreClick(){
                this.$router.push({name: 'HdSearch'})
            },
            //换一批
            _refresh(){
                this._getLike()
            },
            //跳转至主办方详情
            goHostDet(id){
                this.$router.push({name: 'HdHost',query:{hostid:id}})
            },
            getAdvertisement(code, request) {
                // 取得广告接口
                getAdConfig({
                    data: {adcode: code},
                    success: data=> {
                        this.setLoading(false)
                        request(data.data.content)
                    },
                    error: data => {
                        this.setLoading(false)
                        this.$message.error(data.msg)
                    }
                })
            },
            routeAdvertisement(href) {  // 广告跳转
                window.open(href, '_blank')
            },
            ...mapActions([
                'setLoading',
            ])
        },
        components:{
            IndexList,
            // IndexSilder,
            RankList
        },
        computed: {
            ...mapGetters(['domainInfo'])
        },
    }
</script>

<style lang="scss">
    .HdIndex{
        background: #fff;
        .banner-wrap{
            .el-carousel__item--card.is-active{
                width: 1200px;
                box-shadow: 0 0 10px #999!important;
                margin-left: -600px;
                left: 25%;
            }
            .el-carousel__indicators--outside{
                display: none;
            }
        }
        .index_wrap{
            width: 1200px;
            margin: auto;
            // padding: 20px 0;
            .page-module{
                margin-top: 30px;
                padding: 0 0;
                cursor: pointer;
                img{
                    width: 100%;
                }
            }
            .list_box{
                width: 100%;
                .t{
                    display: flex;
                    justify-content: space-between;
                    margin: 20px 0;
                    /*margin-bottom: 10px;*/
                    .title{
                        height:24px;
                        font-size:24px;
                        font-weight:bold;
                        color:#333;
                        line-height:20px;
                        border-left: 3px solid #1464C8;
                        padding-left: 10px;
                    }
                    .more{
                        height:14px;
                        font-size:14px;
                        font-weight:400;
                        color:rgba(204,204,204,1);
                        line-height:20px;
                        cursor: pointer;
                        display: flex;
                        align-items: center;
                        img{
                            margin-right: 5px;
                        }
                    }
                }
                .margin-30{
                    margin: 30px 0;
                }
                .margin30{
                    margin-bottom: 30px;
                }
                .list{
                    display: flex;
                    justify-content: space-between;
                    .list_item{
                        margin: 0 10px;
                        min-width: 285px;
                    }
                }
                .like_list{
                    display: flex;
                    flex-wrap: wrap;
                    /*justify-content: space-between;*/
                    .likeItem{
                        width: 285px;
                        margin-bottom: 20px;
                        margin-right: 20px;
                    }
                    .likeItem:nth-child(4n){
                        margin-right: 0;
                    }
                }
                .like_list:after {
                    content: "";
                    width:285px;
                }
                .seeMore{
                    width:280px;
                    height:40px;
                    line-height: 40px;
                    text-align: center;
                    background:rgba(255,255,255,1);
                    border:1px solid rgba(229,229,229,1);
                    color: #999;
                    margin: 30px auto;
                    display: flex;
                    align-items: center;
                    cursor: pointer;
                    img{
                        width: 13px;
                        height: 10px;
                        margin-right: 10px;
                        margin-left: 90px;
                    }
                }
                .sponsor_wrap{
                    display: flex;
                    align-items: center;
                    .leftBox{
                        width: 490px;
                        min-width: 490px;
                        height: auto;
                        max-height: 200px;
                        display: flex;
                        border:1px solid rgba(229,229,229,1);
                        cursor: pointer;
                        img{
                            width: 210px;
                            min-width: 210px;
                            height: 200px;
                            background: #eee;
                        }
                        .desp{
                            margin-left: 10px;
                            font-size: 12px;
                            color: #999;
                            line-height: 25px;
                            .title{
                                font-size: 14px;
                                color: #333;
                                margin-bottom: 10px;
                                margin-top: 10px;
                            }
                            .rowTwo{
                                height: 124px;
                                display: -webkit-box;
                                -webkit-box-orient: vertical;
                                -webkit-line-clamp: 5;
                                overflow: hidden;
                            }
                            .rowline{
                                margin: 0 5px;
                                color: #e5e5e5;
                            }
                        }
                    }
                    .rightBox{
                        display: flex;
                        flex-wrap: wrap;
                        justify-content: space-between;
                        .sponsorList{
                            width: 330px;
                            height: auto;
                            max-height: 90px;
                            display: flex;
                            border:1px solid rgba(229,229,229,1);
                            margin: 10px;
                            cursor: pointer;
                            img{
                                width: 90px;
                                min-width: 90px;
                                height: 90px;
                                background: #eee;
                            }
                            .desp{
                                margin-left: 10px;
                                font-size: 12px;
                                color: #999;
                                line-height: 25px;
                                .title{
                                    font-size: 14px;
                                    color: #333;
                                    margin-top: 10px;
                                }
                                .rowTwo{
                                    width: 220px;
                                    height: 24px;
                                    overflow: hidden;
                                    text-overflow:ellipsis;
                                    white-space: nowrap;
                                }
                                .rowline{
                                    margin: 0 5px;
                                    color: #e5e5e5;
                                }
                            }
                        }
                    }
                }
                /*轮播样式更改*/
                .el-carousel__indicators--outside{
                    height: 20px;
                    position: absolute;
                    right: 0px;
                    top: 0;
                }
                .el-carousel{
                    position: static;
                }
                .el-carousel__indicators--outside button{
                    width: 6px;
                    height: 6px;
                    background: #ccc;
                    border-radius: 50%;
                    opacity: 1;
                }
                .el-carousel__indicator.is-active button{
                    width:18px;
                    height:6px;
                    background:rgba(20,100,200,1);
                    border-radius:3px;
                }
                .el-carousel__indicator{
                    position: relative;
                    right: -275px;
                }
            }
            .flex_listBox{
                display: flex;
                margin: 10px 0;
                .left{
                    width: 895px;
                    min-width: 895px;
                    margin-right: 20px;
                    .active_list{
                        display: flex;
                        flex-wrap: wrap;
                        justify-content: space-between;
                        .list_box{
                            width: 285px;
                            margin-top: 20px;
                        }
                    }
                }
                .right{
                    width: 285px;
                    min-width: 285px;
                }
            }
        }
    }
</style>